// extracted by mini-css-extract-plugin
export default {"container":"Post_container__aq7mJ","progressContainer":"Post_progressContainer__xjOp9"};